const styles = () => ({
  container: {
    border: '1px solid #e5e5e5'
  }
})

export default styles
